import './bootstrap';
// import '../css/app.css';

// import '../../node_modules/admin-lte/build/scss/adminlte.scss'
// import '../scss/lte_custom.scss'

// import 'bootstrap'

import Notifications from '@kyvg/vue3-notification'
import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
// import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';

// Vselect
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

// Thêm dòng này để đảm bảo Vue DevTools có thể kết nối
if (process.env.NODE_ENV === 'local') {
    window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app;
}

createInertiaApp({
    resolve: name => require(`./Pages/${name}.vue`),
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(Notifications)
            .component('v-select', vSelect)
            .use(ZiggyVue, Ziggy)
            .mount(el)
    },
});

InertiaProgress.init({ color: '#4B5563' });
